import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import main from '@/components/main'
import business from '@/components/business'
import about from '@/components/about'
import gz_idc from '@/components/gz_idc'
import hy_idc from '@/components/hy_idc'
import sbjy from '@/components/sbjy'
import si_card from '@/components/si_card'
import si_verify from '@/components/si_verify'
import agent from '@/components/agent'
import agent_hct from '@/components/agent_hct'
import protocol from '@/components/protocol'

// import BaiduMap from 'vue-baidu-map'
// import {BmlMarkerClusterer} from 'vue-baidu-map'

Vue.use(Router)
// Vue.use(BaiduMap, {
// 	ak: 'VCkowSnHUVx5d2DzCWnvsIu5dS7RLuac'
// })
// Vue.component('bml-marker-cluster', BmlMarkerClusterer)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
			children: [
				{path: '/', name: 'main', component: main},
				{path: 'about', name: 'about', component: about},
				{path: 'business', name: 'business', component: business},
				{path: 'gz_idc', name: 'gz_idc', component: gz_idc},
				{path: 'hy_idc', name: 'hy_idc', component: hy_idc},
				{path: 'sbjy', name: 'sbjy', component: sbjy},
				{path: 'si_card', name: 'si_card', component: si_card},
				{path: 'si_verify', name: 'si_verify', component: si_verify},
				{path: 'agent', name: 'agent', component: agent},
				{path: 'agent_hct', name: 'agent_hct', component: agent_hct},
				{path: 'protocol', name: 'protocol', component: protocol}
			]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js